import { DeviceRefVdt, UserRefVdt } from './reference-vdt';

export enum TraitTypeEnum {
  Type = 'Type',
  TypeWitness = 'Type-Witness',
  Who = 'Who',
  WhoBiometrics = 'Who-Biometrics',
  What = 'What',
  When = 'When',
  Where = 'Where',
  WhereDevice = 'Where-Device',
}

export interface VdtAttribute {
  trait_type: TraitTypeEnum;
  value: string;
}

export interface IpfsMetadata {
  ipfs: string;
  name: string;
  image: string;
  qrCode: { image: string; url: string };
  eventId: string;
  refVdts: {
    userVdt: UserRefVdt;
    deviceVdt: DeviceRefVdt;
  };
  vdtType: string;
  bitSysId: string;
  attributes: VdtAttribute[];
  description: string;
  beingIdLevel: {
    current: {
      activeAt: Date;
      endedAt?: Date;
      level: string;
    };
    history: {
      activeAt: Date;
      endedAt?: Date;
      level: string;
    }[];
  };
}
